import { DashboardLayout } from "../client/components/Sidebar";
import { Link } from "react-router-dom";

export default function TestDashboardPage() {
  return (
    <DashboardLayout>
      <div className="w-full">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            Welcome to Gedoba! 🎉
          </h1>
          <p className="text-lg text-gray-600">
            This is a test page to preview the new dashboard layout without
            authentication.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {/* Module Cards */}
          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-purple-600">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                <span className="text-2xl">📢</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Notices</h3>
                <p className="text-sm text-gray-500">Community announcements</p>
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">12</div>
            <p className="text-sm text-gray-500 mt-1">Active notices</p>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-blue-500">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <span className="text-2xl">📅</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Events</h3>
                <p className="text-sm text-gray-500">Upcoming activities</p>
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">8</div>
            <p className="text-sm text-gray-500 mt-1">This month</p>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-cyan-600">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-cyan-100 rounded-lg flex items-center justify-center">
                <span className="text-2xl">🏢</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Tenants</h3>
                <p className="text-sm text-gray-500">Business directory</p>
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">24</div>
            <p className="text-sm text-gray-500 mt-1">Active businesses</p>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-green-600">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <span className="text-2xl">🛒</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Buy & Sell</h3>
                <p className="text-sm text-gray-500">Marketplace items</p>
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">45</div>
            <p className="text-sm text-gray-500 mt-1">Active listings</p>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-blue-500">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <span className="text-2xl">🔍</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Lost & Found</h3>
                <p className="text-sm text-gray-500">Missing items</p>
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">6</div>
            <p className="text-sm text-gray-500 mt-1">Pending items</p>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-purple-500">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                <span className="text-2xl">🔧</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Services</h3>
                <p className="text-sm text-gray-500">Service providers</p>
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">18</div>
            <p className="text-sm text-gray-500 mt-1">Available services</p>
          </div>
        </div>

        {/* Instructions */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h2 className="text-xl font-semibold text-blue-900 mb-3">
            ✅ Phase 1 Complete!
          </h2>
          <p className="text-blue-800 mb-4">
            The sidebar navigation is now working. Try clicking on the "About"
            and "Community" section headers to see them collapse and expand.
          </p>
          <div className="space-y-2 text-sm text-blue-700">
            <p>• Click section headers to collapse/expand (⭐ ↔ ⭕)</p>
            <p>
              • Click the menu button (☰) in the top bar to hide/show the
              sidebar
            </p>
            <p>• Resize your browser to see mobile responsiveness</p>
            <p>• All menu items are color-coded for easy identification</p>
          </div>

          <div className="mt-6 p-4 bg-white rounded border border-blue-300">
            <h3 className="font-semibold text-blue-900 mb-2">
              🚀 Try the Notice Board!
            </h3>
            <p className="text-sm text-blue-800 mb-3">
              The Notice Board is now fully functional! Click the links below to
              see it in action:
            </p>
            <div className="space-y-2 text-sm text-blue-800">
              <p>
                •{" "}
                <Link
                  to="/locations/tech-innovation-hub/notices"
                  className="underline font-medium hover:text-blue-600"
                >
                  Tech Innovation Hub Notice Board
                </Link>
              </p>
              <p>
                •{" "}
                <Link
                  to="/locations/sunset-towers/notices"
                  className="underline font-medium hover:text-blue-600"
                >
                  Sunset Towers Notice Board
                </Link>
              </p>
              <p>
                •{" "}
                <Link
                  to="/locations/creative-workspace/notices"
                  className="underline font-medium hover:text-blue-600"
                >
                  Creative Workspace Notice Board
                </Link>
              </p>
            </div>
          </div>

          <div className="mt-6 p-4 bg-white rounded border border-blue-300">
            <h3 className="font-semibold text-blue-900 mb-2">Want to login?</h3>
            <ol className="list-decimal list-inside space-y-1 text-sm text-blue-800">
              <li>
                Go to{" "}
                <a href="/signup" className="underline font-medium">
                  /signup
                </a>
              </li>
              <li>Create an account with any email (test@test.com works)</li>
              <li>Check your terminal for the verification link</li>
              <li>Click the link to verify your account</li>
              <li>
                You're in! Access the full demo at{" "}
                <a href="/dashboard" className="underline font-medium">
                  /dashboard
                </a>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
